import { createAction } from '@ngrx/store';

export const listenSocketCallDeclineMessage = createAction(
  '[Connect] Listen to socket call decline message',
);

export const listenSocketOnCancelVideoCall = createAction(
  '[Connect] Start listen to call cancelled socket event',
);

export const stopListenSocketCancelVideoCall = createAction(
  '[Connect] Stop listen to call cancelled socker event',
);
